import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class SetRouteService {

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) { }

  setRouteSessionStrorage(home?: string): void {
    let url = this.router.url.split('?')[0];
    if (home) { url = 'home'; }
    let urlRewrite: string;

    const { structure, universe } = this.route.snapshot.queryParams;

    if (structure && !universe) {
      urlRewrite = `${url}?structure=${structure}`;
    } else if (!structure && universe) {
      urlRewrite = `${url}?universe=${universe}`;
    } else if (structure && universe) {
      urlRewrite = `${url}?structure=${structure}&universe=${universe}`;
    } else {
      urlRewrite = url;
    }


    sessionStorage.setItem('route', urlRewrite);
  }


}
